import { useState, useEffect } from 'react';
import EnrollmentByAge from '../components/charts/EnrollmentByAge';
import TotalPremiumByPlanType from '../components/charts/TotalPremiumByPlanType';
import Video from '../components/video-component/Video';
import IngagedContactsTable from '../components/contacts/Contacts';
import Document from '../components/document-component/Document';
import Multimedia from '../components/multimedia-component/Multimedia';
import ChildPortal from './child-portal-component/ChildPortal';
import LinkComponent from './link-component/LinkComponent';
import AssetUpload from '../components/asset-upload-component/AssetUpload';
import { resolveSSOLinks } from '../utils/resolveSSOLinks';
import { getText } from '../i18n';

export function ContentType({
    ContentTypeID,
    data,
    editMode,
    handleSetBackgroundColor,
    onAssetUploadComplete,
    onLinkClick,
    portalName,
    portalId,
    navigationStack,
    isPreview = false,
    isViewLive = false,
    isMobile = false,
    onShowPortalView,
}) {
    const [contentType, setContentType] = useState();

    const replaceSSOLinks = text => {
        if (editMode || isPreview || isViewLive) {
            return Promise.resolve(
                text?.replace(/https:\/\/ssoId:\d+/g, '#sso-blocked'),
            );
        }

        return resolveSSOLinks(text);
    };

    useEffect(() => {
        switch (ContentTypeID) {
            case 1: {
                let ageRanges = [];

                if (data && data.data && data.data.ageBands) {
                    ageRanges = data.data.ageBands.map(band => {
                        return {
                            min: band.lowerBound,
                            max: band.upperBound,
                            name: band.planType,
                            count: band.count,
                        };
                    });
                }

                setContentType(<EnrollmentByAge ageRanges={ageRanges} />);
                break;
            }
            case 2: {
                setContentType(
                    <TotalPremiumByPlanType
                        planTypeCosts={data.data.planTypeCosts}
                        premiumByPlanTypePart={data.premiumByPlanTypePart}
                    />,
                );
                break;
            }
            case 3: {
                let url = '';

                if (data.videoPart.url) {
                    url = data.videoPart.url;
                } else {
                    //url = "https://www.youtube.com/watch?v=TIASy1IxUKs";
                }

                let caption = '';

                if (data.videoPart.caption) {
                    caption = data.videoPart.caption;
                } else {
                    //caption = "Effective employee communication meets employees where they are. As your work environment changes, you can ensure your plan and your people continue to thrive with iNGAGED.";
                }

                setContentType(
                    <Video
                        url={url}
                        caption={caption}
                        id={data.id}
                        portalId={portalId}
                        portalName={portalName}
                        isViewLive={isViewLive}
                    />,
                );
                break;
            }
            case 4: {
                setContentType(<p>{getText('msg_d93ba65dd065')}</p>);
                break;
            }
            case 5: {
                setContentType(<p>{getText('msg_d219c68101f5')}</p>);
                break;
            }
            case 6: {
                setContentType(<p>{getText('msg_50e19fda0d5b')}</p>);
                break;
            }
            case 7: {
                // let contactsTableData = [];
                // if (data && data.contactsPart && data.contactsPart.data) {
                //   contactsTableData = JSON.parse(data.contactsPart.data);
                // }
                setContentType(
                    <IngagedContactsTable
                        containerAssets={data.containerAssets}
                        isMobileOverride={isMobile}
                    />,
                );
                break;
            }
            case 8: {
                let docCaption = '';

                if (data?.documentPart?.caption) {
                    docCaption = data.documentPart.caption;
                }
                setContentType(
                    <Document
                        data={data}
                        caption={docCaption}
                        title={data.title}
                        editMode={editMode}
                        containerAssets={data.containerAssets}
                        id={data.id}
                        portalId={portalId}
                        portalName={portalName}
                        isViewLive={isViewLive}
                    />,
                );
                break;
            }
            case 9: {
                (async () => {
                    let multimediaPartCaption = await replaceSSOLinks(
                        data.multimediaPart?.text ?? '',
                    );
                    setContentType(
                        <Multimedia
                            url={data.multimediaPart?.video ?? ''}
                            caption={multimediaPartCaption}
                            containerAssets={data.containerAssets}
                            id={data.id}
                            name={data.title}
                            navigationStack={navigationStack}
                            portalId={portalId}
                            editMode={editMode}
                            isPreview={isPreview}
                            isViewLive={isViewLive}
                            button={data.multimediaPart.buttonText}
                            handleSetBackgroundColor={handleSetBackgroundColor}
                            tenantSSOId={data.multimediaPart.tenantSSOId}
                            onLinkClick={onLinkClick}
                            onShowPortalView={onShowPortalView}
                        />,
                    );
                })();
                break;
            }
            case 10: {
                (async () => {
                    let childPortalPartText = await replaceSSOLinks(
                        data.childPortalPart.text,
                    );
                    setContentType(
                        <ChildPortal
                            title={data.title}
                            icon={data.childPortalPart.glyph}
                            foregroundColor={
                                data.childPortalPart.foregroundColor
                            }
                            backgroundColor={
                                data.childPortalPart.backgroundColor
                            }
                            images={data.childPortalPart.images}
                            caption={data.childPortalPart.caption}
                            text={childPortalPartText}
                            button={data.childPortalPart.buttonText}
                            link={data.childPortalPart.childPortalId}
                            handleSetBackgroundColor={handleSetBackgroundColor}
                            onLinkClick={onLinkClick} // Adding as support for older / deprecated typ
                        />,
                    );
                })();
                break;
            }
            case 11: {
                (async () => {
                    let linkPartText = await replaceSSOLinks(
                        data.linkPart.text,
                    );
                    setContentType(
                        <LinkComponent
                            title={data.title}
                            icon={data.linkPart.glyph}
                            foregroundColor={data.linkPart.foregroundColor}
                            backgroundColor={data.linkPart.backgroundColor}
                            image={data.linkPart.image}
                            caption={data.linkPart.caption}
                            text={linkPartText}
                            button={data.linkPart.buttonText}
                            handleSetBackgroundColor={handleSetBackgroundColor}
                            tenantSSOId={data.linkPart.tenantSSOId}
                            data={data}
                            onLinkClick={onLinkClick}
                        />,
                    );
                })();
                break;
            }
            case 12: {
                (async () => {
                    let assetUploadPartText = await replaceSSOLinks(
                        data.assetUploadPart.text,
                    );
                    setContentType(
                        <AssetUpload
                            containerId={data.id}
                            containerTitle={data.title}
                            containerAssetUploadPart={data.assetUploadPart}
                            onAssetUploadComplete={onAssetUploadComplete}
                            dueDate={data.dueDate}
                            assets={data.containerAssets}
                            text={assetUploadPartText}
                            acceptedFileTypes={
                                data.assetUploadPart
                                    .assetUploadPartAllowedFileTypes
                            }
                            portalName={portalName}
                            portalId={portalId}
                            navigationStack={navigationStack}
                            editMode={editMode}
                            isPreview={isPreview}
                            isViewLive={isViewLive}
                            onShowPortalView={onShowPortalView}
                            url={data.assetUploadPart?.video ?? ''}
                        />,
                    );
                })();
                break;
            }
            default: {
                setContentType(<p>{getText('msg_0646f4afd90c')}</p>);
                break;
            }
        }
    }, [ContentTypeID, data]); //Had to add the variable here to re-render

    return <>{contentType}</>;
}
